<div class="calendar-form-control">
  <!-- Header -->
  <div class="calendar-form-control__header">
    <!-- Flecha izquierda -->

    <icon-solid-button
      [disabled]="prevDisabled()"
      [icon]="ArrowLeftOutline"
      (click)="changeMonth(-1)"
      class="calendar-form-control__nav calendar-form-control__nav--prev" />
    <div class="calendar-form-control__current">
      <dropdown-form-control
        class="calendar-form-control__month"
        [options]="monthsOptions()"
        [value]="viewDate().getMonth()"
        (valueChange)="updateMonth($event)" />

      <dropdown-form-control
        class="calendar-form-control__year"
        [options]="yearsOptions()"
        [value]="viewDate().getFullYear()"
        (valueChange)="updateYear($event)" />
    </div>

    <!-- Flecha derecha -->
    <div
      (click)="changeMonth(1)"
      class="calendar-form-control__nav calendar-form-control__nav--next">
      <icon-solid-button
        [icon]="ArrowRightOutline"
        [disabled]="nextDisabled()" />
    </div>
  </div>

  <div class="calendar-form-control__body">
    <div class="calendar-form-control__weekday">Lu</div>
    <div class="calendar-form-control__weekday">Ma</div>
    <div class="calendar-form-control__weekday">Mi</div>
    <div class="calendar-form-control__weekday">Ju</div>
    <div class="calendar-form-control__weekday">Vi</div>
    <div class="calendar-form-control__weekday">Sa</div>
    <div class="calendar-form-control__weekday">Do</div>

    @for (day of daysGrid(); track $index) {
    <div
      [class.calendar-form-control__day--other-month]="!day.inMonth"
      [class.calendar-form-control__day--selected]="day.isSelected"
      [class.calendar-form-control__day--range-start]="day.isRangeStart"
      [class.calendar-form-control__day--range-end]="day.isRangeEnd"
      [class.calendar-form-control__day--in-range]="day.isInRange"
      [class.calendar-form-control__day--disabled]="day.disabled"
      (click)="selectDay(day)"
      class="calendar-form-control__day">
      {{day.label}}
    </div>
    }
  </div>
</div>
